<template>
    <div class="payment-status">
        <CheckCirclePaymentIcon class="payment-icon"/>
        <div class="payment-message">
            Payment Was Successful. Thank you!
        </div>
        <div class="trans-id">
            <div class="trans">
                Transaction ID:
            </div>
            <div class="trans">
                {{ txRef }}
            </div>
        </div>
    </div>
    <div class="verify-activity">
        <LoadingIndicator v-if="loading" message="Verifying Payment..."/>
        <!-- <SystemMessage v-if="!loading && error" :message="message"/> -->
        <div v-if="!loading && error" class="error-message">
        <div class="errors-block">
            <div class="error-heading">Unable to verify payment and restore service</div>
            <div class="error-subheading">This could be due to a temporary internet connection issue or a brief glitch on our end. Don't worry, your payment is safe. Please try one of the three options below to get back online.</div>
            <div class="options">
                <div class="options-heading">1. Payment Verification & Service Restoration</div>
                <div class="context">Our system performs continuous, automated checks around the clock to verify user transactions and activate services. If your services haven't been restored yet, please allow between 15 minutes to an hour for the system to fully process and resolve the issue.</div>
            </div>
            <div class="options">
                <div class="options-heading">2. Manual Payment Verification</div>
                <div class="context">This is the absolute fastest way to restore your services. Simply head over to the bottom of the <router-link style="color:var(--page-header);text-decoration: none;" to="/billing">Billing</router-link> page and click the "Verify Payment" button at any time.</div>
            </div>
             <div class="options">
                <div class="options-heading">3. Contact Support</div>
                <div class="context">If the issue persists (though we expect it won't), please reach out to our support team. We're here to help get everything sorted out for you.</div>
            </div>
        </div>
        </div>
        
    </div>
</template>
<script>
import PageHeader from '@/components/Utility/PageHeader.vue';
import CheckCirclePaymentIcon from '@/components/IconComponents/CheckCircleIcon.vue';
import LoadingIndicator from '@/components/Utility/LoadingIndicator.vue';
import SystemMessage from '@/components/Utility/SystemMessage.vue';
import { VerifyPayment } from '@/services/billing/billingService';
import router from '@/router';
export default {
    components:{
        PageHeader, 
        CheckCirclePaymentIcon, 
        LoadingIndicator, 
        SystemMessage
    },
    data(){
        return{
            txRef:"",
            loading:true,
            error:false,
            message:"Unable to restore feature access. Please try refreshing the page or contact support."
        }
    },
    computed:{
        authUser(){
            return this.$store.getters['auth/getAuthenticatedUser'];
        }
    },
    mounted(){
        this.txRef =  this.$route.query.tx_ref;
        setTimeout(async() => await this.verifyPaymentAsync(), 2000);
    },
    methods:{
        async verifyPaymentAsync(){
        try{
            this.loading = true;
            this.error = false;
            let response = await VerifyPayment();
            if(!response.success){
                let err = new Error(response.message);
                err.reason = response.caption;
                throw err;
            }else{
                if(!this.canAccess('enterprise')){
                    this.$router.push("/");
                }else{
                    this.$router.push("/enterprise/home");
                }
            }
        }catch(e){
              this.loading = false;
              this.message = "Unable to restore feature access. Please try refreshing the page or contact support.";
              this.error = true;
        }
        },
        canAccess(routeName) {
        // Resolve the route by name. `resolved.matched` contains the matched route records.
        const resolved = this.$router.resolve({ name: routeName })

        // Use the most-specific matched record (last entry) so child route meta is respected.
        const matched = resolved?.matched || []
        if (!matched.length) return false // route not found

        const record = matched[matched.length - 1]
        const meta = record.meta || {}

        // Read token from localStorage (used by guards elsewhere in the app).
        const token = localStorage.getItem('token')

        // Prefer the `authUser` from the Vuex store. Fall back to the `user` stored in localStorage.
        let user = this.authUser.value
        if (!user) {
            try {
            user = JSON.parse(localStorage.getItem('user'))
            } catch (e) {
            user = null
            }
        }

        // If the route requires authentication and there's no token, deny access.
        if (meta.requiresAuth && !token) {
            return false
        }

        // If the route specifies allowed roles, check the user's role in multiple possible shapes:
        //  - user.roles: an array of role strings
        //  - user.userType: a single role stored under `userType` (used in signup)
        //  - user.role: another common single-role field
        if (meta.roles) {
            let hasRole = false
            if (Array.isArray(user?.roles)) {
            hasRole = user.roles.some(role => meta.roles.includes(role))
            } else if (user?.userType) {
            hasRole = meta.roles.includes(user.userType)
            } else if (user?.role) {
            hasRole = meta.roles.includes(user.role)
            }
            if (!hasRole) return false
        }

        // No checks failed — allow access.
        return true
        }
    }
}
</script>
<style scoped>
.options-heading{
    color:var(--page-header);
    font-size:1.3rem;
    margin-bottom:0.6rem;
}
.options{
    margin-bottom:1rem;
}

.context{
    font-size:0.9rem;
}

.error-subheading{
    font-size:0.9rem;
    margin-bottom:0.8rem;
}

.error-heading{
    color:var(--red);
    font-size:1.3rem;
    margin-bottom:0.6rem;
}

.errors-block{
    grid-column:2/3;
}
.error-message{
    display:grid;
    grid-template-columns:repeat(3, 1fr);
}

.payment-status{
    margin-top:3rem;
    margin-bottom:2rem;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.trans-id{
    display: flex;
    flex-direction: column;
    align-items: center;
    
}

.trans:first-child{
    font-size:0.8rem;
}

.trans:last-child{
    font-size:0.9rem;
}

.payment-icon, .payment-message{
    color:var(--green);
}

.payment-message{
    font-size:1.4rem;
    margin-bottom:0.4rem;
}

.payment-icon{   
    height:5rem;
    width:5rem;
    margin-bottom:1rem;
}

.payment-message{
    font-family: var(--heading-font-bold);
}

@media(max-width:768px){
    .payment-icon{   
    height:4rem;
    width:4rem;
    margin-bottom:0.6rem;
}

.payment-message{
    font-size:1.2rem;
}

.error-message{
    grid-template-columns:1fr;
    margin:0rem 0.8rem;
}

}
    
</style>